export default "__VITE_ASSET__D_rI5Zoc__"